import { combineEpics } from 'redux-observable'
import { blockingSourceEpic } from './BlockingSourceEpic.js'
import { autosaveVizEpic } from './AutoSaveVizEpic.js'
import { createRemoteViewEpic } from './CreateRemoteViewEpic.js'
import { deleteRemoteViewEpic } from './DeleteRemoteViewEpic.js'
import { loadRemoteViewEpic } from './LoadRemoteViewEpic.js'
import { listRemoteViewsEpic } from './ListRemoteViewsEpic.js'
import { traitLoadingEpic } from './TraitLoadingEpic.ts'
import { cubeLoaderEpic } from './CubeLoaderEpic.ts'
import { cubeAutoRequestEpic } from './CubeAutoRequestEpic.ts'
import { cubePrefetchEpic } from './CubePrefetchEpic.ts'
import { cubePrefetchLoaderEpic } from './CubePrefetchLoaderEpic.ts'
import { sourceReadyEpic } from './SourceReadyEpic.ts'
import { taxaPathRepairEpic } from './TaxaPathRepairEpic.ts'
import { cacheResetEpic } from './CacheResetEpic.ts'

export const visualizationEpics = combineEpics(
  blockingSourceEpic,
  autosaveVizEpic,
  createRemoteViewEpic,
  deleteRemoteViewEpic,
  loadRemoteViewEpic,
  listRemoteViewsEpic,
  traitLoadingEpic,
  cubeLoaderEpic,
  cubeAutoRequestEpic,
  cubePrefetchEpic,
  cubePrefetchLoaderEpic,
  sourceReadyEpic,
  taxaPathRepairEpic,
  cacheResetEpic
)
